module.exports = __webpack_public_path__ + "img/banner_er.e23e9ce1.png";